/**
 * Shared motion guard. Single definition for "should we animate at all?" —
 * honoured by every motion primitive (Reveal, count-up, hero entrance, FlowDemo)
 * so the answer is consistent and there's one place to reason about it.
 *
 * Returns true when the OS "Reduce motion" preference is set, OR when there's no
 * window (SSR / Puppeteer prerender) — so prerendered HTML is captured at the
 * final, settled state rather than mid-animation.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return true;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
